// Import model
import { DataviewNoteResponse } from '../models/DataviewNoteResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterNoteRequest } from '../models/FilterNoteRequest';
import { Note } from '../models/Note';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterNoteRequestSerializer } from './FilterNoteRequestSerializer';
import { NoteSerializer } from './NoteSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewNoteResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewNoteResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewNoteResponse instance
   */
  static deserialize(json: string): DataviewNoteResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewNoteResponse instance
   */
  static fromObject(obj: any): DataviewNoteResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewNoteResponse');
    }


    const instance: DataviewNoteResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        NoteSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterNoteRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewNoteResponse instances
   */
  static deserializeArray(json: string): DataviewNoteResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewNoteResponse instance to a JSON string
   */
  static serialize(instance: DataviewNoteResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewNoteResponse instance to a plain object
   */
  static toObject(instance: DataviewNoteResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        NoteSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterNoteRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewNoteResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewNoteResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
